module.exports = __webpack_public_path__ + "img/4.73156b45.jpg";